import { render, staticRenderFns } from "./research-site.vue?vue&type=template&id=c5c62866&scoped=true&"
import script from "./research-site.vue?vue&type=script&lang=js&"
export * from "./research-site.vue?vue&type=script&lang=js&"
import style0 from "./research-site.vue?vue&type=style&index=0&id=c5c62866&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c62866",
  null
  
)

component.options.__file = "research-site.vue"
export default component.exports